export default 'M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24m-3.94-9.44a1.5 1.5 0 0 1-2.12-2.12l5-5a1.5 1.5 0 0 1 2.12 0l5 5a1.5 1.5 0 0 1-2.12 2.12L12 10.62z';